<template>
    <v-tab-item :value="WEB.value">
        <section class="sub-section">
            <v-container>
                <div class="section-title mb-32 mb-lg-56">
                    <h3 class="tit--lg text-center mb-30 mb-lg-44">
                        <!-- What is Web Application Firewall (WAF)? -->
                        {{ settings.product.webcastle.first }}
                    </h3>
                    <p class="page-text-lg color-grey-57 text-center mb-12 mb-lg-22">
                        Unlike network firewalls, it is specialized in web application security and is a security method that detects, responds to, and blocks attacks on websites or servers called SQL Injection and XSS.
                    </p>
                    <p class="page-text-lg color-grey-57 text-center mb-12 mb-lg-22">
                        In addition to the existing web attack response function, it performs functions such as information leakage prevention, illegal access blocking, and file forgery prevention.
                    </p>
                    <p class="page-text-lg color-grey-57 text-center">
                        It is specially developed for web application defense, so it prevents the exposure of web security vulnerabilities and blocks malicious codes from being uploaded from outside. (Prevention of web vulnerability exposure is the original function of web scanner and secure coding)
                    </p>
                </div>

                <v-row>
                    <v-col cols="12" lg="6" class="mb-20 mb-lg-0">
                        <div class="radius-lg bg-grey">
                            <p class="w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14">
                                Appliance Based Web Firewall (Hardware)
                            </p>
                            <div class="pa-16 pt-md-22 pb-md-80 px-md-42">
                                <v-img class="d-block mb-28 mb-lg-48" max-width="498" src="/images/sub/products/web/s1-img1-en.png"></v-img>
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · Appliance type
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · Independent box type like other security products
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · Performance is differentiated by hourly traffic throughput capacity
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm">
                                    · It is located in front of the web server and in front of the L4 switch when there are multiple web servers.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="radius-lg bg-grey">
                            <p class="w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14">
                                Software Based Web Firewall (Software)
                            </p>
                            <div class="pa-16 pt-md-22 pb-md-80 px-md-42">
                                <v-img class="d-block mb-28 mb-lg-48" max-width="498" src="/images/sub/products/web/s1-img2-en.png"></v-img>
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · Web security filter type
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · Software type directly mounted on the web server
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · The performance of the web firewall is determined by the capacity of the web server.
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm">
                                    · When installing a web firewall, there is no change in the existing network configuration
                                </p>
                            </div>
                        </div>
                    </v-col>
                </v-row>

            </v-container>
        </section>

        <section class="sub-section bg-grey">
            <v-container>

                <h3 class="tit--lg text-center">
                    <!-- Comparison of web firewall (WAF) type -->
                    {{ settings.product.webcastle.second }}
                </h3>

                <v-row>
                    <v-col cols="12" lg="6" class="mb-20 mb-lg-0">
                        <div class="radius-lg bg-white h-100">
                            <p class="w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14">
                                Cloud Dedicated Web Firewall (Software)
                            </p>
                            <div class="pa-16 pb-0 px-md-42 pt-md-70">
                                <v-img class="d-block mx-auto " max-width="469" src="/images/sub/products/web/s2-img1.png"></v-img>
                            </div>
                            <div class="pa-16 px-md-40 pt-md-40 px-lg-70 pt-lg-70 pb-md-120">
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · Located on a Web server, CPU (3% or less) internal resources of the server are utilized with minimal server resources
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm mb-6 mb-lg-16">
                                    · With one connection from the web server, 
                                    minimize the delay in web service response speed due to 
                                    web firewall function by inspecting request data, 
                                    processing, and response data
                                </p>
                                <p class="page-text-sm color-grey-49 dot-txt-sm">
                                    · Secure sockets layer (SSL) traffic is treated 
                                    the same as cleartext traffic.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="radius-lg bg-white h-100">
                            <p class="w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14">
                                VM based web firewall(Hardware)
                            </p>
                            <div class="pa-16 pb-0 px-md-42 pt-md-70">
                                <v-img class="d-block mx-auto " max-width="469" src="/images/sub/products/web/s2-img2-en.png"></v-img>
                            </div>
                            <div class="pa-16 px-md-40 pt-md-40 px-lg-70 pt-lg-70 pb-md-120">
                                <div class="dot-txt-sm mb-8 mb-lg-24">
                                    <p class="page-text-sm color-grey-49 mb-4 mb-lg-10">
                                        · A web firewall located in front of multiple web servers is a traffic load issue.
                                    </p>
                                    <p class="font-size-12 font-size-lg-16 color-grey-49 bar-txt line-height-15">
                                        - Connection for hacking inspection of Request Data in web firewall
                                    </p>
                                    <p class="font-size-12 font-size-lg-16 color-grey-49 bar-txt line-height-15">
                                        - Connection for process processing in web server
                                    </p>
                                    <div class="bar-txt">
                                        <p class="font-size-12 font-size-lg-16 color-grey-49 line-height-15">
                                            - Connection for inspection of response data in web firewall
                                        </p>
                                        <p class="font-size-12 font-size-lg-16 color-grey-49 arrow-txt line-height-15">
                                            → 4 connections occur in one process, resulting in web service speed degradation
                                        </p>
                                    </div>
                                </div>
                                <div class="dot-txt-sm">
                                    <p class="page-text-sm color-grey-49 mb-4 mb-lg-10">
                                        · It must be configured separately for each network according to the processing capacity per hour.
                                    </p>
                                    <p class="font-size-12 font-size-lg-16 color-grey-49 bar-txt line-height-15">
                                        - Network configuration becomes complicated
                                    </p>
                                    <p class="font-size-12 font-size-lg-16 color-grey-49 bar-txt line-height-15">
                                        - Network problems due to sudden increase in traffic
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>

                <h3 class="tit--lg text-center">
                    <!-- Market-proven F1-WEBCastle's key features -->
                    {{ settings.product.webcastle.third }}
                </h3>

                <v-row>
                    <v-col cols="12" md="6" lg="4">
                        <div class="border-light h-100">
                            <div class="py-28 py-lg-40 d-flex justify-center">
                                <v-img class="d-block " max-width="65" src="/images/sub/products/web/s3-icon1-1.png"></v-img>
                            </div>
                            <p class="text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12 min-h-md-20 min-h-lg-24 d-flex align-center justify-center">
                                Security control and integrated management
                            </p>
                            <div class="pa-16 pa-md-24">
                                <p class="color-grey-49 text-center page-text-sm">
                                    Administrators can check the status of multiple web servers and cyber attacks in real time on the same UI screen, and provide a dashboard that allows you to grasp overall statistics at a glance.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <div class="border-light h-100">
                            <div class="py-28 py-lg-40 d-flex justify-center">
                                <v-img class="d-block " max-width="65" src="/images/sub/products/web/s3-icon1-2.png"></v-img>
                            </div>
                            <p class="text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12 min-h-md-20 min-h-lg-24 d-flex align-center justify-center">
                                Management of connection security between the central server and the agent
                            </p>
                            <div class="pa-16 pa-md-24">
                                <p class="color-grey-49 text-center page-text-sm">
                                    The traffic between the central server manager and the webcastle agent is encrypted with SSL to provide a security function that prevents interception.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <div class="border-light h-100">
                            <div class="py-28 py-lg-40 d-flex justify-center">
                                <v-img class="d-block " max-width="65" src="/images/sub/products/web/s3-icon1-3.png"></v-img>
                            </div>
                            <p class="text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12 min-h-md-20 min-h-lg-24 d-flex align-center justify-center">
                                Consistent security policy setting
                            </p>
                            <div class="pa-16 pa-md-24">
                                <p class="color-grey-49 text-center page-text-sm">
                                    Consistent security policy setting according to security policy by company and group,
                                    Providing a security management function that can control access or block threats.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <div class="border-light h-100">
                            <div class="py-28 py-lg-40 d-flex justify-center">
                                <v-img class="d-block " max-width="65" src="/images/sub/products/web/s3-icon1-4.png"></v-img>
                            </div>
                            <p class="text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12 min-h-md-20 min-h-lg-24 d-flex align-center justify-center">
                                Detection & defense solution with no performance degradation when applying SSL
                            </p>
                            <div class="pa-16 pa-md-24">
                                <p class="color-grey-49 text-center page-text-sm">
                                    For safe web communication in accordance with the revised Personal Information Protection Act, there is no degradation in performance when responding to and defending against web attacks using SSL (Secure Socket Layer) usage rate soaring.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <div class="border-light h-100">
                            <div class="py-28 py-lg-40 d-flex justify-center">
                                <v-img class="d-block " max-width="65" src="/images/sub/products/web/s3-icon1-5.png"></v-img>
                            </div>
                            <p class="text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12 min-h-md-20 min-h-lg-24 d-flex align-center justify-center">
                                Segmented log management
                            </p>
                            <div class="pa-16 pa-md-24">
                                <p class="color-grey-49 text-center page-text-sm">
                                    All related logs such as log-in records, usage records, history management, detection and blocking histories for administrators and attackers according to the security policy remain,  in case of a problem, we can take a preemptive response.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <div class="border-light h-100">
                            <div class="py-28 py-lg-40 d-flex justify-center">
                                <v-img class="d-block " max-width="65" src="/images/sub/products/web/s3-icon1-6.png"></v-img>
                            </div>
                            <p class="text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12 min-h-md-20 min-h-lg-24 d-flex align-center justify-center">
                                Remote integrated security management
                            </p>
                            <div class="pa-16 pa-md-24">
                                <p class="color-grey-49 text-center page-text-sm">
                                    As long as the Internet is connected, any web server located anywhere in Korea and abroad can be installed and operated online, and integrated security management is possible according to the security policy.
                                </p>
                            </div>
                        </div>
                    </v-col>
                </v-row>

            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_EN_TABS } from "@/assets/variables";
const { WEB } = PRIVATE_SALES_EN_TABS;
import api from "@/api"
export default {
    data() {
        return {
            WEB,
            settings: null,
            filter: {
                code: "en"
            }
        };
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        }
    }
};
</script>

<style>



</style>
